module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicator"
  }, [_c('div', {
    staticClass: "indicator__icon",
    class: {
      'indicator__icon_positive': _vm.isPositive
    }
  }, [(_vm.tooltipText.length) ? _c('div', {
    staticClass: "indicator__tooltip"
  }, [_vm._v(_vm._s(_vm.tooltipText))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109bf81e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/indicator/Indicator.vue
// module id = a552180826e30330fc22
// module chunks = 89